<template>
    <div>
        <v-carousel cycle height='80vh' hide-delimiter-background show-arrows-on-hover interval='15000'>
            <pre>

            </pre>
            <v-carousel-item v-for='(slider, i) in statistics' :key='i'>
                <v-sheet height='100%'>
                    <div class='statistic'>
                        <div v-if='i === statistics.length - 2'>
                            <div class='group align--center'>
                                <span class='table__header'>название</span>
                                <span class='table__header'>план</span>
                                <span class='table__header'>факт</span>
                                <span class='table__header'>процент</span>
                            </div>

                            <div v-for='(sub_group, index) in slider' :key='index' class='group align--center'>

<!--                                <span class='table__group-name'>{{ sub_group.name }} Всего</span>-->
                                <span class='table__group-name'>Всего</span>
                                <span class='table__number plan_fact--green'>{{ sub_group.plan }} </span>
                                <span class='table__number'
                                      :class="sub_group.fact >= sub_group.plan ? 'plan_fact--green' : 'plan_fact--red'"
                                >
                                    {{ sub_group.fact }}
                                </span>
                                <span class='table__number'
                                      :class="sub_group.percent >= 100 ? 'plan_fact--green': 'plan_fact--red'">{{ sub_group.percent
                                    }} %</span>
                            </div>
                            <div class='group'>
                                <span class='last-row'>Средний процент выполнения <span
                                    class='table__number'>{{ middle_percent.toFixed(2) }} %</span> </span>
                            </div>
                        </div>
                        <div v-if='i === statistics.length - 1'>
                            <h2>Информация по ДПФ</h2>
                            <div class='group-brigade align--center'>
                                <span class='table__header table__header--first'>Бригада</span>
                                <span class='table__header'>Последняя смена</span>
                                <!-- <span class='table__header'>Сегодня на человека</span> -->
                                <span class='table__header'>Всего </span>
                                <!-- <span class='table__header'>Всего на человека</span> -->
                            </div>

                            <div v-for='(sub_group, index) in slider' :key='index' class='group-brigade align--center'>
                                <span class='table__group-name table__header--first'>{{ sub_group.name }}</span>
                                <span class='table__number plan_fact--green'>
                                    {{ sub_group.hasOwnProperty('values') ?  sub_group.values.current_day_dpf.toFixed(2) : 0 }}
                                </span>
                                <!-- <span class='table__number plan_fact--green w300'>
                                    {{ sub_group.hasOwnProperty('values') && sub_group.values.current_day_dpf && sub_group.values.amount_quantity  ?  +(sub_group.values.current_day_dpf / sub_group.values.amount_quantity).toFixed(2)  : 0 }}
                                </span> -->
                                <span class='table__number plan_fact--green'>
                                    {{ sub_group.hasOwnProperty('values') ?  +sub_group.values.amount_dpf.toFixed(2) : 0 }}
                                </span>
                                <!-- <span class='table__number plan_fact--green'>
                                    {{ sub_group.hasOwnProperty('values') && sub_group.values.amount_dpf ?  +(sub_group.values.amount_dpf / sub_group.values.amount_quantity).toFixed(2)  : 0 }}
                                </span> -->
                            </div>

                        </div>
                        <div v-for='group in slider' :key='group._id' class='group' v-else>

                            <div
                                class='product'
                                v-for='product in group.products'
                                :key='product._id'
                                :class='set_product_class(product)'
                            >
<!--                                <div class='description'>-->
<!--                                    <div class='name'>{{ product.name }}</div>-->
<!--                                    <div-->
<!--                                        class='image'-->
<!--                                        :style="{ backgroundImage: `url('/images/products/${product.image}')` }"-->
<!--                                    >-->
<!--                                        <v-progress-linear-->
<!--                                            :color='set_color(product)'-->
<!--                                            height='50'-->
<!--                                            :value='count_value(product)'-->
<!--                                            background-opacity='0.3'-->
<!--                                        >-->
<!--                                            <template>-->
<!--                                                <strong>{{ product.fact }} / {{ product.plan }}</strong>-->
<!--                                            </template>-->
<!--                                        </v-progress-linear>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <template v-if='product.accessories.length'>
                                    <div
                                        class='accessory'
                                        v-for='accessory in product.accessories'
                                        :key='accessory._id'
                                    >
                                        <div class='name'>{{ accessory.name }}</div>
                                        <div
                                            class='image'
                                            :style="{
                                                backgroundImage: `url('/images/accessories/${accessory.image}')`,
                                            }"
                                        >
                                            <v-progress-linear
                                                :color='set_color(accessory)'
                                                height='50'
                                                :value='count_value(accessory)'
                                                background-opacity='0.3'
                                            >
                                                <template>
                                                    <strong>{{ accessory.fact }} / {{ accessory.plan }}</strong>
                                                </template>
                                            </v-progress-linear>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>

        <div class='small_total'>
            <div class='date'>
                {{
                    get_statistics.date
                        ? `${get_statistics.time} ${formated_date(get_statistics.date)}`
                        : 'Все смены на данный момент закрыты. А новых планов не поставлено'
                }}
            </div>
            <!-- <div class='small_total_item'>
                <h3>ДПФ</h3>
                <div class='plan_fact'>
                    <span class='plan_fact--green'>{{ dpf ? +dpf.toFixed(2) : 0 }}</span> <span class='small'>₽</span>
                </div>
            </div>
            <div class='small_total_item'>
                <h3>ДПФ ВСЕГО</h3>
                <div class='plan_fact'>
                    <span class='plan_fact--green'>{{
                            all_dpfs ? +(+all_dpfs.toFixed(2) + +dpf.toFixed(2)).toFixed(2) : 0
                        }}</span>
                    <span class='small'>₽</span>
                </div>
            </div> -->
            <div class='small_total_item'>
                <h3>Предыдущий план</h3>
                <div class='plan_fact'>
                    <span class='plan_fact--green'>
                        {{ get_before_statistic && get_before_statistic.totals ? get_before_statistic.totals.middle_percent : ''
                        }}
                    </span>
                    <span class='small'>%</span>
                </div>
            </div>
            <div class='small_total_item'>
                <h3>План</h3>
                <div class='plan_fact'>
                    <template v-if='middle_percent >= 100'>
                        <span class='plan_fact--green'>{{
                                middle_percent
                                    ? (middle_percent).toFixed(2)
                                    : 0
                            }}</span>
                        <span class='small'>%</span>
                    </template>
                    <template v-else>
                        <span class='plan_fact--red'>{{
                                middle_percent
                                    ? (middle_percent).toFixed(2)
                                    : 0
                            }}</span>
                        <span class='small'>%</span>
                    </template>
                </div>
            </div>
        </div>
        <v-container fluid>
            <v-row class='ma-4'>
                <v-dialog v-model='dialog' persistent width='90vw'>
                    <!-- Форма создания комплектубщей -->
                    <div class='news'>
                        <img :src='`/images/news/${image}`' class='news__image' />
                        <div>
                            <div class='news__title'>{{ title }}</div>
                            <div class='news__date'>
                                {{ formated_news_date(date) }}
                            </div>
                            <div class='news__text' v-html='nl2br(text)'></div>
                        </div>
                    </div>
                </v-dialog>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'StatisticsView',
    data() {
        return {
            for_modal: {
                title_for_modal: null,
                text_for_modal: null,
                _id_for_modal: null,
            },
            selectedTab: null,
            products: null,
            products_2: null,
            error_text: null,
            dialog: false,
            title: null,
            text: null,
            date: null,
            image: null,
            statistic_interval: null,
            news_interval: null,
            total_product_plan: 0,
            total_product_fact: 0,
            dpf: null,
            news: [],
            sub_groups: {},
            middle_percent: 0,
            total_plan: 0,
            total_fact: 0,
            position: 0,
            local_percent: 0,
            brigades: []
        }
    },
    created() {
        // загружаем все новости
        this.load_news()
        // загружаем первую открытую статистику с датой
        this.load_statistics()

        // включаем интервал для обновления новостей
        this.news_interval = setInterval(this.load_news, 5 * 60 * 1000)
        // включаем интервал для обновления статистики
        this.statistic_interval = setInterval(this.load_statistics, 5000)

        setInterval(this.check, 5 * 60 * 1000) // выводим новости через промежуток
        // setInterval(this.get_statistics, 5 * 1000) // Расчет итого по статистике
    },
    computed: {
        ...mapGetters(['get_news_by_check', 'get_statistics', 'get_before_statistic', 'get_brigades']),

        statistics() {
            const MAX_SLIDE_WEIGHT = 15
            const MAX_GROUP_WEIGHT = 8

            let sliders = []
            let slider = new Array()
            let counter = 0

            this.total_product_plan = 0
            this.total_product_fact = 0
            this.local_percent = 0
            this.dpf = 0
            this.all_dpfs = this.get_statistics.all_dpfs
            if (this.get_statistics.groups) {
                const local_groups = JSON.parse(JSON.stringify(this.get_statistics.groups)).filter(
                    (group) => group.products && group.products.length,
                )
                this.sub_groups = {}
                this.middle_percent = 0
                this.total_plan = 0
                this.total_fact = 0
                console.log(local_groups, 'local_groups');
                local_groups.forEach((group, index) => {

                    group.weight = 0

                    // считаем итоговые план и факт по продукции
                    group.products.forEach((product) => {

                        if (group.including) {
                            this.total_product_plan += product.plan
                            this.total_product_fact += product.fact
                        } else {
                            console.log('wtf')
                        }

                        this.dpf += product.ratio * 1 * product.fact

                        // оппределяем вес группы на экране
                        group.weight += product.accessories.length + 1

                        if (product.sub_group) {

                            const x = this.sub_groups[product.sub_group]
                            if (!x){

                                this.sub_groups[product.sub_group] = []
                            }
                            this.sub_groups[`${product.sub_group}`].push({ plan: product.plan, fact: product.fact })
                        } else {
                            // console.log(product)
                        }


                    })
                    // если группа занимает больше 8 квадратов - значит она занимает несколько строк, иначе отдаем группе всю строку

                    group.weight =
                        group.weight > MAX_GROUP_WEIGHT
                            ? Math.ceil(group.weight / MAX_GROUP_WEIGHT) * MAX_GROUP_WEIGHT
                            : MAX_GROUP_WEIGHT






                    let max_products = []


                    group.products.forEach((p,index) => {
                        counter += 1
                        if(counter <=MAX_SLIDE_WEIGHT){
                            max_products.push(p)
                            
                        }
                        
                        if(counter > MAX_SLIDE_WEIGHT || index === group.products.length - 1){
                            
                            slider.push({
                                name: group.name,
                                products: max_products
                            })

                            sliders.push(slider)
                            counter = 0
                            slider = []
                            max_products = []
                            max_products.push(p)
                        }


                    })

                    // sliders.push(slider)


                    console.log(sliders)

                    // if (counter + group.weight <= MAX_SLIDE_WEIGHT) {
                    //     slider.push(group)
                    //     counter += group.weight
                    //
                    //     // если группы закончились, кладем их в последний слайдер
                    //
                    //     if (index == local_groups.length - 1) sliders.push(slider)
                    //
                    //     // если не влазит создаем новый слайдер и обнуляем счетчик веса
                    // } else {
                    //     sliders.push(slider)
                    //
                    //     slider = new Array()
                    //     slider.push(group)
                    //     counter = group.weight
                    //
                    //     if (index == local_groups.length - 1) sliders.push(slider)
                    // }


                })
                const values = []

                for (const [key, value] of Object.entries(this.sub_groups)) {
                    let sub_group = {
                        plan: 0,
                        fact: 0,
                        percent: 0,
                        name: key,
                    }

                    value.forEach(val => {
                        sub_group.plan += val.plan
                        sub_group.fact += val.fact
                    })

                    sub_group.percent = ((sub_group.fact / sub_group.plan) * 100).toFixed(2) * 1

                    this.local_percent += sub_group.percent

                    this.total_plan += sub_group.plan
                    this.total_fact += sub_group.fact


                    values.push(sub_group)
                }

                if(this.total_plan !== 0)
                    this.middle_percent =  this.total_fact * 100 / this.total_plan

                this.local_percent = this.local_percent / Object.keys(this.sub_groups).length
                sliders.push(values)

                this.set_total({
                    total: {
                        dpf: this.dpf,
                        total_product_plan: this.total_product_plan,
                        total_product_fact: this.total_product_fact,
                        percent: ((this.total_product_fact / this.total_product_plan) * 100).toFixed(2),
                    },
                })
            }


            sliders.push(this.get_brigades)
            return sliders
        },
    },
    methods: {
        ...mapActions(['load_statistics', 'load_news', 'authenticate', 'update_news', 'set_total']),

        // Определяем на сколько процентов нужно закрасить прогресс
        count_value(item) {
            if (item.fact == 0) return 0
            const fact = parseInt(item.fact)
            const plan = parseInt(item.plan)
            return (fact / plan) * 100
        },
        // Выбираем цвет прогресса
        set_color(item) {
            return item.fact >= item.plan ? 'green' : 'red'
        },

        set_product_class(item) {
            return item.fact >= item.plan ? 'product--green' : 'product--red'
        },
        formated_date(date) {
            return new Date(date).toLocaleDateString('ru-RU')
        },
        formated_news_date(date) {
            return new Date(date).toLocaleDateString('ru-RU', {
                year: 'numeric',
                month: 'long',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            })
        },
        nl2br(item) {
            return (item + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2')
        },
        check() {
            if (this.get_news_by_check.length) {
                if (this.news.length) {
                    if (this.news.length != this.get_news_by_check.length) {
                        this.news = this.get_news_by_check
                        this.position = 0
                    } else {
                        this.get_news_by_check.forEach((news) => {
                            const first_news = this.news.find((n) => n._id == news._id)

                            if (!first_news) {
                                this.news = this.get_news_by_check
                                this.position = 0
                            }
                        })
                    }
                } else {
                    this.news = this.get_news_by_check
                }

                this.title = this.news[this.position].title
                this.text = this.news[this.position].text
                this.image = this.news[this.position].image
                this.date = this.news[this.position].createdAt
                this.for_modal._id_for_modal = this.news[this.position]._id
                this.dialog = true
                setTimeout(() => {
                    // через какое время скроется новость
                    this.dialog = false

                    if (this.news.length - 1 > this.position) this.position += 1
                    else this.position = 0
                }, 60 * 1000)
            }
        },
    },
    beforeDestroy: function() {
        clearInterval(this.statistic_interval)
        clearInterval(this.news_interval)
    },
}
</script>

<style scoped>
h2 {
    text-align: center;
    text-transform: uppercase;
    font-size: 32px;
    padding: 16px 0;
}

.table__header {
    font-size: 32px;
    text-align: center;
    min-width: 240px;
}

.last-row {
    text-align: center;
    width: 100vw;
    font-size: 32px;
}

.last-row .table__number {
    padding-left: 25px;
}

.table__header:first-of-type, .table__group-name {
    width: 700px;
    margin-right: 25px;
    text-align: right;
    font-size: 32px;
}

.table__header--first {
    width: 300px !important;
    margin-right: 25px;
    text-align: right;
    font-size: 32px;
}

.table__number {
    font-size: 60px;
    width: 240px;
    text-align: center;
}

.plan_fact--green {
    color: rgb(76, 175, 80);
}

.plan_fact--red {
    color: rgb(244, 67, 54);
}


.statistic {
    //display: grid;
    display: flex;
    flex-wrap: wrap;
}

.group {
    display: flex;
    flex-wrap: wrap;
    gap: 36px;
    padding: 10px;
    margin-bottom: 15px;
}

.group-brigade {
    display: flex;
    flex-wrap: wrap;
    gap: 0px;
    padding: 10px;
    margin-bottom: 15px;
    align-items: center;
}

.group.align--center {
    align-items: center;
    margin-top: 25px;
}

.product {
    font: 15px/24px 'Open Sans', Arial, sans-serif;
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    border-radius: 6px;
    display: flex;
    gap: 15px;
}

.product.product--red {
    background-color: rgba(244, 67, 54, 0.3);
}

.product.product--green {
    background-color: rgba(76, 175, 80, 0.3);
}

.product .name {
    font-size: 26px;
    padding: 6px 10px 0;
    min-width: 200px;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
}

.product .image {
    display: flex;
    height: 220px;
    align-items: flex-end;
    background-position: center 10px;
    background-repeat: no-repeat;
    background-size: 80%;
    background-color: #fff;
}

.accessory {
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    min-width: 200px;
}

.accessory .image {
    display: flex;
    height: 220px;
    align-items: flex-end;
    background-position: center 10px;
    background-repeat: no-repeat;
    background-size: 80%;
    background-color: #fff;
}

.v-progress-linear__content strong {
    font-size: 40px;
}

v-progress-linear {
    border-radius: 4px;
}

.d-flex {
    align-items: center;
    justify-content: center;
    height: 60vh;
    gap: 150px;
}

.small_total {
    display: flex;
    justify-content: space-around;
}

.small_total .date {
    font-size: 60px;
    line-height: 1;
}

.small_total_item {
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.small_total_item h3 {
    font-size: 32px;
    text-align: center;
    margin-right: 15px;
}

.small_total_item span {
    font-size: 60px;
    line-height: 1;
}

.small_total_item .plan_fact span.plan_fact--red {
    color: rgb(244, 67, 54);
}

.small_total_item .plan_fact span.plan_fact--green {
    color: rgb(76, 175, 80);
}

.small_total_item .plan_fact span.small {
    font-size: 40px;
    padding: 0 15px;
}

.total_item h3 {
    text-transform: uppercase;
    font-size: 36px;
    text-align: center;
}

.total_item .plan_fact {
    text-align: center;
}

.total_item .plan_fact span {
    font-size: 110px;
}

.total_item .plan_fact span.plan_fact--red {
    color: rgb(244, 67, 54);
}

.total_item .plan_fact span.plan_fact--green {
    color: rgb(76, 175, 80);
}

.total_item .plan_fact span.small {
    font-size: 80px;
    padding: 0 15px;
}

.news {
    display: flex;
    align-items: flex-start;
    background-color: #fff;
    padding: 40px;
}

.news__image {
    object-fit: contain;
    width: 500px;
    margin-right: 32px;
}

.news__title {
    font-size: 64px;
    margin-bottom: 32px;
}

.news__date {
    font-size: 32px;
    margin-bottom: 32px;
}

.news__text {
    font-size: 48px;
    line-height: 1.5;
}

.w300 {
    min-width: 300px;
}
</style>
